module.exports = __webpack_public_path__ + "img/fuli.6afca5e0.png";